import qs from 'qs';
import { apiCall } from './common.js';

export const getUserDetails = () => apiCall({endpoint: 'users/me', method: 'GET'});
export const getUsers = () => apiCall({endpoint: 'users', method: 'GET'});


export async function startBasicAuthLogIn(username, password) {
    let response = new Promise((resolve, reject) => {
        fetch('/api/token', {
            method: 'POST',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: qs.stringify({ username, password })
        })
        .then((r) => {
            if (r.ok) {
                r.json().then((j) => {
                    localStorage.setItem('user', JSON.stringify({ username, token: j.access_token }))
                    resolve(j);
                });
            } else {
                r.json().then((j) => reject(j.detail));
            }
            
        });
        
    });
    return response;
}

export async function startOauthLogIn() {
    let response = new Promise((resolve, reject) => {
        fetch("/api/dex/login", {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            },
            redirect: 'manual'
        }).then((r) => {
        if (r.ok) {
            r.json().then((r) => resolve(r));
        } else {
            r.json().then((r) => reject(r.detail));
        }
        });
    })
    return response;
}

export async function passOauthCallback(params) {
    let response = new Promise((resolve, reject) => {
        fetch(`/api/oauth/callback?${params}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        })
        .then((r) => {
            if (r.ok) {
                r.json().then((j) => {
                    localStorage.setItem('user', JSON.stringify({ email: j.user.email, groups: j.user.groups, token: j.access_token, username: j.user.full_name }))
                    resolve(j);
                });
            } else {
                r.json().then((j) => reject(j.detail));
            } 
        });
    });
    return response;
}

export const logOut = () => {
    localStorage.removeItem('user');
}
